module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit(_vm.item)
      }
    }
  }, [_c('div', [(!_vm.amountFromTransfer) ? _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.settlementType)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_deductionTypes"
    }
  }, [_vm._v("Type rozliczenia")]), _vm._v(" "), _c('dropdown-search', {
    attrs: {
      "elements": _vm.settlementTypesToShow,
      "emptyValue": "Wybierz typ",
      "id": "_deductionTypes",
      "nameField": "name",
      "valueField": "value"
    },
    model: {
      value: (_vm.item.settlementType),
      callback: function($$v) {
        _vm.$set(_vm.item, "settlementType", $$v)
      },
      expression: "item.settlementType"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.settlementType) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_deductionTypes_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.settlementType))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.deductionType)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_deductionTypes"
    }
  }, [_vm._v(_vm._s(_vm.deductionTyleLabel))]), _vm._v(" "), _c('dropdown-search', {
    attrs: {
      "elements": _vm.deductionTypesToShow,
      "emptyValue": "Wybierz typ",
      "id": "_deductionTypes",
      "nameField": "name"
    },
    model: {
      value: (_vm.selectedDeductionType),
      callback: function($$v) {
        _vm.selectedDeductionType = $$v
      },
      expression: "selectedDeductionType"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.deductionType) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_deductionTypes_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.deductionType))]) : _vm._e()], 1), _vm._v(" "), (_vm.invoiceToDeductionLoading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.selectedDeductionType && _vm.selectedDeductionType.systemType == 'invoice' && _vm.invoiceToDeductionLoading == false) ? _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.factoredInvoice)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_factoredInvoice"
    }
  }, [_vm._v("Faktura")]), _vm._v(" "), _c('dropdown-search', {
    attrs: {
      "elements": _vm.invoiceToDeduction,
      "emptyValue": "Wybierz fakturę",
      "isSearch": true,
      "id": "_factoredInvoice",
      "nameField": "fullName"
    },
    model: {
      value: (_vm.selectedInvoiceToDeduction),
      callback: function($$v) {
        _vm.selectedInvoiceToDeduction = $$v
      },
      expression: "selectedInvoiceToDeduction"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.factoredInvoice) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_factoredInvoice_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.factoredInvoice))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.invoiceToRefundLoading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.selectedDeductionType && _vm.selectedDeductionType.systemType == 'refund' && _vm.invoiceToRefundLoading == false) ? _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.refundFactoredInvoice)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_refundFactoredInvoice"
    }
  }, [_vm._v("Faktura")]), _vm._v(" "), _c('dropdown-search', {
    attrs: {
      "elements": _vm.invoiceToRefund,
      "emptyValue": "Wybierz fakturę",
      "isSearch": true,
      "id": "_refundFactoredInvoice",
      "nameField": "fullName"
    },
    model: {
      value: (_vm.selectedInvoiceToRefund),
      callback: function($$v) {
        _vm.selectedInvoiceToRefund = $$v
      },
      expression: "selectedInvoiceToRefund"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.refundFactoredInvoice) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_refundFactoredInvoice_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.refundFactoredInvoice))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.selectedDeductionType && _vm.selectedDeductionType.systemType == 'transfer') ? _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.transferType)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_transferTypes"
    }
  }, [_vm._v("Typ przelewu")]), _vm._v(" "), _c('dropdown-search', {
    attrs: {
      "elements": _vm.transferTypes,
      "emptyValue": "Wybierz przelew",
      "id": "_transferTypes",
      "nameField": "name"
    },
    model: {
      value: (_vm.selectedTransferType),
      callback: function($$v) {
        _vm.selectedTransferType = $$v
      },
      expression: "selectedTransferType"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.transferType) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_transferTypes_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.transferType))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.deductionDate)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_deductionDate"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Data"
    },
    model: {
      value: (_vm.item.deductionDate),
      callback: function($$v) {
        _vm.$set(_vm.item, "deductionDate", $$v)
      },
      expression: "item.deductionDate"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.deductionDate) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_data_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.deductionDate))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.amount)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_amount"
    }
  }, [_vm._v("Kwota")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.currencyName
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "id": "_amount"
    },
    model: {
      value: (_vm.item.amount),
      callback: function($$v) {
        _vm.$set(_vm.item, "amount", $$v)
      },
      expression: "item.amount"
    }
  })], 1), _vm._v(" "), (_vm.errors && _vm.errors.amount) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_amount_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.amount))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.comments)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_comments"
    }
  }, [_vm._v("Uwagi")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.comments),
      expression: "item.comments"
    }],
    staticClass: "form-control full-width",
    attrs: {
      "type": "text",
      "placeholder": "",
      "id": "_comments"
    },
    domProps: {
      "value": (_vm.item.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "comments", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.comments) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_comments_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.comments))]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb9e632c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreement/FormDeduction.vue
// module id = 851
// module chunks = 0